import { render, staticRenderFns } from "./PriceIcon.vue?vue&type=template&id=d64e335e&scoped=true&"
import script from "./PriceIcon.vue?vue&type=script&lang=ts&"
export * from "./PriceIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64e335e",
  null
  
)

export default component.exports